import AppState from '../../AppState';
const onePlatformApiError = () => {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { Window, context, settings } = drupalJsObjects;
    const { baseUrl } = settings;
    context.querySelectorAll('#address-tile, #multi-address-tile, #address-check-progress, #service-available, #service-unavailable')
        .forEach((tile) => tile.style.display = 'none');
    context.querySelector('#api-issue').style.display = 'block';
    context.querySelector('#api-issue #address-confirmation-3').style.display = 'none';
    context.querySelector('.see-all-plans').remove();
    context.querySelector('#exit-api-issue').onclick = (event) => {
        event.preventDefault();
        Window.location.href = `${baseUrl}/nbn-plans`;
    };
};
export default onePlatformApiError;
